export enum UserAction {
  SET_USER = 'set_user',
  UPDATE_CANDIDATE_CONFIG = 'update_candidate_config',
}
